import * as z from "zod/v4";

export const setupContextualDomain = {
  name: "setupContextualDomain" as const,
  input: z.object({ domain: z.string() }),
  output: z.object({ hostnameId: z.string() }),
};
